import { ORDER_STATUS_BUCKET } from '@klareospace/pharos-lib-types';
import type { OrderStatus } from '@klareospace/pharos-lib-types';

import type { StatusBucketKey } from '../types/order.types';

// ─── Utils ────────────────────────────────────────────────────────────────────

/** Resolves which status bucket (PENDING/TODO/IN_PROGRESS/DONE) an order status belongs to. */
export function resolveStatusBucket(status: OrderStatus): StatusBucketKey {
  const entries = Object.entries(ORDER_STATUS_BUCKET) as [StatusBucketKey, readonly OrderStatus[]][];
  const match = entries.find(([, statuses]) => statuses.includes(status));
  if (!match) {
    throw new Error(`[resolveStatusBucket] Unknown order status '${status}' — not present in any ORDER_STATUS_BUCKET.`);
  }
  return match[0];
}
